import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellSingleTextLine.styles';
import { Typography } from '../../../base-components';
import { EMPTY_CELL } from '../../../../common';

interface Props extends IBaseCellsProps {
    data: { text: string };
}
const CellSingleTextLine = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            <Typography variant={'body2'}>
                {data?.text || EMPTY_CELL}
            </Typography>
        </StyledTableCell>
    );
};

export default CellSingleTextLine;
